import type { StaticEntityType } from "@config";
import { normalizedFromNestedStructured } from "@/shared";
import type { StoryStateType } from "../types";

const handleChangeEntityLayout = (
  parentId: string,
  original: StaticEntityType,
  changed: StaticEntityType,
  state: StoryStateType,
  type: "slide" | "combo",
) => {
  const { entities } =
    type === "slide"
      ? normalizedFromNestedStructured(
          [changed],
          "root",
          "slide",
          undefined,
          undefined,
          true,
        )
      : normalizedFromNestedStructured(
          [{ children: [changed] }],
          parentId,
          type,
          undefined,
          undefined,
          true,
        );

  state.flatContentLayers = {
    ...state.flatContentLayers,
    ...entities,
  };
};

export default handleChangeEntityLayout;
